import { useLocation } from "react-router-dom";
import GoogleTranslateInit from "./Language/GoogleTranslateInit";
import GoogleTranslateFloat from "./Language/GoogleTranslateFloat";
import AccessibilityWidget from "./Accessibility/AccessibilityWidget";
import WhatsAppFloat from "./Whatsapp/WhatsAppFloat";
import CallFloat from "./Whatsapp/CallFloat";
import ApplyNowFloat from "./Whatsapp/ApplyNowFloat";
import BackToTop from "./Whatsapp/BackToTop";
import ZetyChatFloat from "./ZETY-MASCOT/ZetyChatFloat";

/**
 * Site-wide floating widgets (chat, WhatsApp, call, apply, back-to-top,
 * translate, accessibility). These belong to the public marketing site —
 * on the admin CMS they cover forms and actions, so they are hidden
 * on every /admin/* route.
 */
export default function SiteFloats() {
    const { pathname } = useLocation();

    if (pathname.startsWith("/admin")) {
        return null;
    }

    return (
        <>
            <GoogleTranslateInit />
            <GoogleTranslateFloat />
            <AccessibilityWidget />
            <WhatsAppFloat />
            <CallFloat />
            <ApplyNowFloat />
            <BackToTop />
            <ZetyChatFloat />
        </>
    );
}
